import { Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-order-navigation',
  templateUrl: './order-navigation.component.html',
  styleUrls: ['./order-navigation.component.scss'],
  standalone: false,
})
export class OrderNavigationComponent {
  private router = inject(Router);

  @Input() currentPage: string;
  @Input() isIncludeCampaign?: any;
}
